<dynamic-form [apiName]="apiName"
              [label]="label"
              [group]="formGroup"
              [model]="model"
              [areaName]="areaName"
              [columns]="columns"
              (cancelChange)="cancel()"
              [erroremessage]="erroremessage"
              (submitChange)="save()"
              [noSubmit]="deactivateSave">
        <ng-container class="content" *ngIf="items && items.length>0"> 
         <ngx-treeview [config]="_config" [items]="items" (selectedChange)="values = $event">
        </ngx-treeview>
        </ng-container>
</dynamic-form>
